import { CardVariantsEnum } from "../../stories/Components/Card/interface";
const placeholderItem = {
    id: "",
    title: "",
    url: "",
    image: {
        url: "",
    },
};

export const placeholderItemCardProps = {
    variant: CardVariantsEnum.MEDIA,
    item: placeholderItem,
    aspectRatio: 1.7778,
};

export const gqlMediaAspectRatios = {
    ratio16By9: "RATIO_16_BY_9",
    ratio9By16: "RATIO_9_BY_16",
};
